'use client'

import type { User } from '@/shared/types/user'
import { CardBody } from '@/shared/ui/Card'

import { UserProfileBody } from './Body'
import { FriendsSection } from './FriendsSection'

interface MyProfileBodyProps {
  userProfile: User | null
  currentUserUid: string
  displayName: string
}

export function MyProfileBody({
  userProfile,
  currentUserUid,
  displayName
}: MyProfileBodyProps) {
  if (!userProfile) {
    return (
      <CardBody className="flex flex-col items-center justify-center py-8">
        <p className="text-lg font-semibold text-gray-700">{displayName}</p>
        <p className="text-sm text-gray-500 mt-1">Carregando perfil...</p>
      </CardBody>
    )
  }

  return (
    <>
      <UserProfileBody userProfile={userProfile} itsMe />
      <FriendsSection currentUserUid={currentUserUid} />
    </>
  )
}
